import eventsPageStateManager from './events_page_state_manager';
import EventsPage from './events_page';

export function eventsHubCalendarRoute(store) {
  return {
    path: '/events',
    component: EventsPage,
    exact: true,
    loadData: eventsPageStateManager(store, 'calendar')
  };
}

export function eventsHubDiscoverRoute(store) {
  return {
    path: '/events/video',
    component: EventsPage,
    exact: true,
    loadData: eventsPageStateManager(store, 'discover')
  };
}

export function eventsHubVideoRoute(store) {
  return {
    path: '/events/video/:videoSlug/:videoId',
    component: EventsPage,
    exact: true,
    loadData: eventsPageStateManager(store, 'video')
  };
}
